import React, { Fragment, FC } from 'react';
import { Trans } from 'react-i18next';
import { Typography } from '@material-ui/core';

import { Logo } from 'components';

interface IProps {
  i18nKey: string;
}

const GenericSidebarHeader: FC<IProps> = ({ i18nKey }) => (
  <Fragment>
    <Logo />
    <Typography gutterBottom variant="h4" color="textSecondary">
      <Trans i18nKey={i18nKey} />
    </Typography>
  </Fragment>
);

export default GenericSidebarHeader;
